'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:NewhomeCtrl
 * @description
 * # NewhomeCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('NewhomeCtrl', function($routeParams, $location, $controller, cfpLoadingBar, CustomerService,
                                      FlashService, postcodeService) {

    var newHomeVm = this;
    $controller('BaseController', {
      vm: newHomeVm
    });
    var customerId = $routeParams.customerId;
    var homeId = $routeParams.homeId;

    newHomeVm.isExisitingHome = !!homeId;
    newHomeVm.autocomplete = autocomplete;
    newHomeVm.homeData = {
      customerId: '',
      address: '',
      town: '',
      postcode: '',
      homeOwner: false,
      notes: '',
      lawnSize: 0,
      grassCuttingHeight: 0
    };
    newHomeVm.homeData.customerId = customerId;

    newHomeVm.submit = submit;

    activate();

    function activate() {
      if(newHomeVm.isExisitingHome) {
        getHome(homeId);
      }
    }

    function submit(valid) {
      if (valid) {
        newHomeVm.inprogress = true;
        cfpLoadingBar.start();
        var saveHome = newHomeVm.isExisitingHome ? updateHome : addHome;

        saveHome(newHomeVm.homeData)
          .finally(function() {
            newHomeVm.inprogress = false;
            cfpLoadingBar.complete();
          });
      }
    }

    function addHome(homeData) {
      return CustomerService.AddHome(homeData)
        .then(function(_) {
          FlashService.Success('Home added to customer');
          $location.path('/customers/' + customerId);
        }, function(error) {
          FlashService.Error(error.message);
        });
    }

    function updateHome(homeData) {
      return CustomerService.updateHome(homeData)
        .then(function(_) {
          FlashService.Success('Home updated');
          $location.path('/customers/' + newHomeVm.homeData.customerId);
        })
        .catch(function(error) {
          FlashService.Error(error.message);
        });
    }

    function getHome(id) {
      cfpLoadingBar.start();
      return CustomerService.getHome(id)
        .then(function(response) {
          newHomeVm.homeData = response;
          newHomeVm.selectedAddress = {
            address: newHomeVm.homeData.address,
            town: newHomeVm.homeData.town
          };
        })
        .catch(function(error) {
          FlashService.Error(error.message);
        })
        .finally(function() {
          cfpLoadingBar.complete();
        });
    }

    function autocomplete(postcode) {
      return postcodeService.autocomplete(postcode)
        .then(function(response) {
          return response;
        });
    }
  });
